export default "__VITE_ASSET__1DyvI13r__"